import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import toastr from "toastr";
import ViewCommentsComponent from "./ViewCommentsComponent";

function CommentPopup(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <span
        className={props.iconClass ? props.iconClass : "pointer btn btn-right"}
        onClick={handleShow}
      >
        {props.name ? props.name : "Decline"}
      </span>

      <Modal size="lg" backdrop="static" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{props.title ? props.title : "Decline Report"} </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ViewCommentsComponent comments={props.comments} />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CommentPopup;
